
const VietnamFlag = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="17" viewBox="0 0 23 17" fill="none">
            <rect x="0.5" y="0.5" width="22" height="16" rx="2" fill="white" />
            <mask id="mask0_1325_7456" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="23" height="17">
                <rect x="0.5" y="0.5" width="22" height="16" rx="2" fill="white" />
            </mask>
            <g mask="url(#mask0_1325_7456)">
                <rect x="0.5" y="0.5" width="22" height="16" fill="#EA403F" />
                <path fillRule="evenodd" clipRule="evenodd" d="M11.4999 10.3722L8.72894 12.3835L9.75134 9.07868L7.01638 7.01691L10.4192 6.98572L11.4999 3.7002L12.5806 6.98572L15.9835 7.01691L13.2485 9.07868L14.2709 12.3835L11.4999 10.3722Z" fill="#FFFE4E" />
            </g>
        </svg>
    )
}

export default VietnamFlag